import { ACTIVITY_TYPE_MESSAGE, ACTIVITY_TYPES } from '../constants/index';
import { Activity } from '../dtos/index';

export const MAP_ACTIVITY_TYPE = (activity: Activity): string => {
	switch (activity.activityType.toLowerCase()) {
		case ACTIVITY_TYPES.QUOTE_CREATED.toLowerCase():
			return ACTIVITY_TYPE_MESSAGE.QUOTE_CREATED;
		case ACTIVITY_TYPES.CARRIER_INVITED.toLowerCase():
			return ACTIVITY_TYPE_MESSAGE.CARRIER_INVITED + activity.carrierBusinessName + ` for ${(activity.amount / 100).toLocaleString("en-US", {style:"currency", currency:"USD"}) }`
				|| 'Carrier';

		case ACTIVITY_TYPES.CARRIER_ACCEPTED.toLowerCase():
			return (ACTIVITY_TYPE_MESSAGE.CARRIER_ACCEPTED + activity.carrierBusinessName || 'Carrier') +
				 ` for ${(activity.amount / 100).toLocaleString("en-US", {style:"currency", currency:"USD"}) }`;
		case ACTIVITY_TYPES.CARRIER_COUNTERED.toLowerCase():
			return (ACTIVITY_TYPE_MESSAGE.CARRIER_COUNTERED + activity.carrierBusinessName || 'Carrier') +
				` for ${(activity.amount / 100).toLocaleString("en-US", {style:"currency", currency:"USD"}) }`;

		case ACTIVITY_TYPES.CARRIER_DECLINED.toLowerCase():
			return ACTIVITY_TYPE_MESSAGE.CARRIER_DECLINED + activity.carrierBusinessName || 'Carrier';

		case ACTIVITY_TYPES.BOOKING_CREATED.toLowerCase():
			return ACTIVITY_TYPE_MESSAGE.BOOKING_CREATED + activity.carrierBusinessName || 'Carrier';

		case ACTIVITY_TYPES.BOOKING_SIGNED.toLowerCase():
			return ACTIVITY_TYPE_MESSAGE.BOOKING_SIGNED + activity.carrierBusinessName || 'Carrier';

		case ACTIVITY_TYPES.ALL_BIDS_SENT.toLowerCase():
			return ACTIVITY_TYPE_MESSAGE.ALL_BIDS_SENT;

		case ACTIVITY_TYPES.ASCEND_BID_CREATED.toLowerCase():
			return ACTIVITY_TYPE_MESSAGE.ASCEND_BID_CREATED + activity.carrierBusinessName || 'Carrier';

		case ACTIVITY_TYPES.BOOKING_CONFIRMATION.toLowerCase():
			return ACTIVITY_TYPE_MESSAGE.BOOKING_CONFIRMATION;

		case ACTIVITY_TYPES.BROKER_COUNTERED.toLowerCase():
			return activity.message.charAt(0).toUpperCase() + activity.message.slice(1);

		default:
			return activity.message;
	}
};
